import _ from "lodash";
import Reflux from "reflux";
import { t } from "i18next";
import {
  SharedActions,
  ActionsListeners__AtsStats,
  ActionsListeners__System,
  ActionsListeners__OnlineUsers,
  ActionsListenerPosthog,
  ActionsListenersBrandKit,
  ActionsListenersConfigurations
  // eslint-disable-next-line import/no-unresolved
} from "@talentbait/shared-components";

import logger from "./utils/LoggerFrontend";
import webAPIUtils from "./utils/WebAPIUtils";
import socketAPIUtils from "./utils/SocketAPIUtils";
import database from "./utils/FirebaseController";
import auth from "./utils/AuthController";
import config from "./utils/config__frontend";
import { SHUTTERSTOCK_API_VERSION } from "./constants";

import CommentSystemActions from "./Actions/Actions__CommentSystem";
import { ActionsDataViz } from "./Actions/ActionsDataViz/ActionsDataViz";

import { app } from "./utils/firebaseUtils";
import { ActionsListenersDataViz } from "./Actions/ActionsDataViz/ActionsListenersDataViz";
import i18n from "./i18n";
import { ActionsListenersMediaAssetsLab } from "./Actions/ActionsMediaAssetsLab/ActionsListenersMediaAssetsLab";
import { ActionsListenersTempDraftCreation } from "./Actions/ActionsTempDraftCreation/ActionsListenersTempDraftCreation";
import { ActionsListenersAdAssistant } from "./Actions/ActionsAdAssistant/ActionsListenersAdAssistant";
import { ActionsListenersCampaignsOverview } from "./Actions/ActionsCampaignsOverview/ActionsListenersCampaignsOverview";
import { ActionsAdAssistant } from "./Actions/ActionsAdAssistant/ActionsAdAssistant";
import { ActionsJobs } from "./Actions/ActionsJobs/ActionsJobs";
import { ActionsListenersJobs } from "./Actions/ActionsJobs/ActionsListenersJobs";
import { ActionsCampaignsOverview } from "./Actions/ActionsCampaignsOverview/ActionsCampaignsOverview";

import { ActionsGlobalMediaLibrary } from "./Actions/ActionsGlobalMediaLibrary/ActionsGlobalMediaLibrary";
import { ActionsListenersGlobalMediaLibrary } from "./Actions/ActionsGlobalMediaLibrary/ActionsListenersGlobalMediaLibrary";
import { ActionsProfile } from "./Actions/ActionsProfile/ActionsProfile";
import { ActionsListenersProfile } from "./Actions/ActionsProfile/ActionsListenersProfile";

const INIT = {
  //--------------------------------------------------------------------------
  // UX
  //--------------------------------------------------------------------------
  addNotification: {},
  //--------------------------------------------------------------------------
  // Campaign Booking
  //--------------------------------------------------------------------------
  // Base data => CampaignCreation Store
  campaignCreateUpdateBaseData: {},
  // Budget calculator => CampaignCreation Store
  campaignCreateUpdateBudgetData: {},
  // Package selector => CampaignCreation Store
  campaignCreateUpdatePackageData: {},
  // ATS form => CampaignCreation Store
  campaignCreateUpdateATSData: {},
  // New Ad Preview => CampaignCreation Store
  campaignCreateUpdatePreviewData: {},
  // Review step => CampaignCreation Store
  campaignCreateUpdateReviewData: {},
  // Reset campaign creation states
  campaignCreateResetData: {},
  // Draft Status => CampaignCreation Store
  campaignCreateUpdateDraftStatus: {},
  campaignUpdateIsFirstCampaign: {},
  //--------------------------------------------------------------------------
  // Campaign
  //--------------------------------------------------------------------------
  loadCampaigns: { asyncResult: true },
  loadFilteredCampaigns: { asyncResult: true },
  loadDailyClicks: { asyncResult: true },
  loadCampaignsByClient: { asyncResult: true },
  updateAtsWithCampaignId: { asyncResult: true },
  getCampaignPerformanceScoring: { asyncResult: true },
  createJobTitleKeywords: { asyncResult: true },
  getKeywordsByJobTitle: { asyncResult: true },
  getAllUserCampaignsById: { asyncResult: true },
  loadSharedCampaignData: { asyncResult: true },

  //--------------------------------------------------------------------------
  // Packages
  //--------------------------------------------------------------------------
  loadPackagesByOrga: { asyncResult: true },
  addPackagesToOrga: { asyncResult: true },
  removePackage: { asyncResult: true },
  editPackage: { asyncResult: true },
  generateAudioClip: { asyncResult: true },
  generateTextRecommendationStream: { asyncResult: true },
  setIsRegeneratingText: { asyncResult: true },
  getAllJingles: { asyncResult: true },
  fetchTikTokPreview: { asyncResult: true },
  generateTikTokPreview: { asyncResult: true },
  generateVideo: { asyncResult: true },
  generateImage: { asyncResult: true },
  generateMedia: { asyncResult: true },
  listenVideoGeneration: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Packages
  //--------------------------------------------------------------------------
  loadAdsets: { asyncResult: true },
  updateAdset: { asyncResult: true },
  loadAdset: { asyncResult: true },
  loadAllActiveCampaigns: { asyncResult: true },
  loadCampaignsByStatusCriteria: { asyncResult: true },
  //loadAllCampaignsByAgency: { asyncResult: true },
  loadAllCampaignsAPI: { asyncResult: true },
  loadSingleCampaignAPI: { asyncResult: true },
  lastNCampaignsQuery: { asyncResult: true },
  loadAllHistoryCampaigns: { asyncResult: true },
  loadAllHistoricCampaigns: { asyncResult: true },
  loadClickMetricsByDay: { asyncResult: true },
  getComments: { asyncResult: true },
  getSocialComments: { asyncResult: true },
  getSocialCommentsCount: { asyncResult: true },
  getCampaignsWithCondition: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Campaigns
  //--------------------------------------------------------------------------
  loadSingleCampaign: { asyncResult: true },
  loadCampaignDataPublic: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Adsets
  //--------------------------------------------------------------------------
  getAdsetsByCampaignId: { asyncResult: true },
  getAdsetById: { asyncResult: true },
  loadAdsetDataPublic: { asyncResult: true },
  getAdsetsByCampaignIdPublic: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Channel Sets
  //--------------------------------------------------------------------------
  getChannelCampaignsByAdsetId: { asyncResult: true },
  getChannelCampaignsByCampaignId: { asyncResult: true },
  updateChannelCampaign: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Other
  //--------------------------------------------------------------------------
  addChannelDataToCampaign: { asyncResult: true },
  // Create an clear
  createCampaignDraft: { asyncResult: true },
  // Create an clear
  sendSlack: { asyncResult: true },
  switchBookingStyle: {},
  loadDraftCampaign: { asyncResult: true },
  clearDraftCampaign: { asyncResult: true },
  deleteDraftCampaign: { asyncResult: true },
  fetchCouponById: { asyncResult: true },
  getCampaignsWithCoupon: { asyncResult: true },
  showCreditModal: { asyncResult: true },
  showInvoiceAddressModal: {},
  showEditInvoiceAddressModal: {},
  validateCampaignCoupon: { asyncResult: true },
  createCoupon: { asyncResult: true },
  updateCoupon: { asyncResult: true },
  getPrepaidTransactions: { asyncResult: true },
  getPrepaidBalance: { asyncResult: true },
  getPrepaidPackages: { asyncResult: true },
  topUpPrepaidMoney: { asyncResult: true },
  createCampaignAndSave: { asyncResult: true },
  createCampaignAndSaveWithId: { asyncResult: true },
  setCampaignLive: { asyncResult: true },
  createCampaignsOnChannels: { asyncResult: true },
  createTalentBaitCampaign: { asyncResult: true },
  createInitialAdsetAndChannelCampaignsForCampaign: { asyncResult: true },
  extendCampaign: { asyncResult: true },
  extendCampaignDate: { asyncResult: true },
  updateCampaignStatus: { asyncResult: true },
  triggerAutomaticCampaignReportTask: { asyncResult: true },
  toggleAdsetChannels: { asyncResult: true },
  recalculateChannelCampaignsBudgets: { asyncResult: true },
  createPlatformsChannelCampaignsOnAdset: { asyncResult: true },
  deleteChannelCampaignById: { asyncResult: true },
  getAllComments: { asyncResult: true },
  clearSingleCampaignData: {},
  changeCampaignDataSingle: {},
  changeFacebookCampaign: { asyncResult: true },
  changeFacebookAdset: { asyncResult: true },
  changeFacebookAdsetEndDate: { asyncResult: true },
  changeFacebookCampaignAdsetsAndAdsField: { asyncResult: true },
  updatePlatformCampaignsEndDates: { asyncResult: true },
  updateDestinationLink: { asyncResult: true },
  changeCampaignData: { asyncResult: true },
  updateCampaignWithId: { asyncResult: true },
  updateCampaignDeployedStatus: { asyncResult: true },
  updateCampaignAdsets: { asyncResult: true },
  deleteCampaignField: { asyncResult: true },
  addLocations: { asyncResult: true },
  getLocationByParams: { asyncResult: true },
  getLocationByParamsAndState: { asyncResult: true },
  changeLeadAdData: { asyncResult: true },
  updateGoogleCampaignField: { asyncResult: true },
  toggleModal: {},
  getActivityStream: { asyncResult: true },
  copyCampaign: { asyncResult: true },
  duplicateCampaign: { asyncResult: true },
  copyAdCreatives: { asyncResult: true },
  copyCampaignATSSettings: { asyncResult: true },
  copyCampaignMembers: { asyncResult: true },
  updateCampaignMembers: { asyncResult: true },
  updateUser: { asyncResult: true },
  moveCampaignATSSettings: { asyncResult: true },
  getFacebookTargeting: { asyncResult: true },
  copyCampaignOnChannel: { asyncResult: true },
  getPlacements: { asyncResult: true },
  getGooglePlacements: { asyncResult: true },
  removeGooglePlacements: { asyncResult: true },
  sendLiveLink: { asyncResult: true },
  getPersonioJobs: { asyncResult: true },
  getRecruiteeJobs: { asyncResult: true },
  getRecruiteeJobById: { asyncResult: true },
  // Everything around Assets
  saveAssets: { asyncResult: true },
  getAssets: { asyncResult: true },
  getAssetsPhotoEditor: { asyncResult: true },
  getAssetsPerformanceEditor: { asyncResult: true },
  deleteCreativeAsset: { asyncResult: true },
  // Everything around Ad Creatives
  saveAdCreative: { asyncResult: true },
  saveAdCreatives: { asyncResult: true },
  deleteAdCreativesByCampaignId: { asyncResult: true },
  updateAdCreative: { asyncResult: true },
  updateAdCreatives: { asyncResult: true },
  deleteAdCreatives: { asyncResult: true },
  getAdCreativesByCampaignId: { asyncResult: true },
  getAdCreativesByCampaignIdAndChannel: { asyncResult: true },
  getLastLinkedInAdCreativesByCompanyAndOrgaId: { asyncResult: true },
  getCampaignAndAdCreativesByCampaignId: { asyncResult: true },
  resetPreviewData: {},

  //--------------------------------------------------------------------------
  // Campaign Creation
  //--------------------------------------------------------------------------
  addPost: {},
  removePost: {},
  updatePost: {},
  updatePostMediaLab: {},
  updateTemplateDataToDownload: {},
  updateChannelData: { asyncResult: true },
  initPosts: { asyncResult: true },
  turnOffDefaultOpenTeaserEditor: {},
  updateEveryChannelURL: { asyncResult: true },
  updateCampaignCreationLoadingState: {},
  updatePreviewCampaignData: {},
  updateQualificationQuestion: {},
  updateATSFormality: {},
  updateChatbotQuestion: {},
  resetQualificationQuestions: {},
  getHistoricalATSData: {},
  saveUploadedPicture: {},
  emitCampaignCreation: {},
  startCampaignCreation: {},
  getOrCreateCompany: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Candidates
  //--------------------------------------------------------------------------
  loadCandidatesCount: { asyncResult: true },
  loadCandidatesList: { asyncResult: true },
  loadCandidate: { asyncResult: true },
  updateCandidatesByCampaignId: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Location lookup
  //--------------------------------------------------------------------------
  locationLookup: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Images
  //--------------------------------------------------------------------------
  uploadMedia: { asyncResult: true },
  searchStockImage: { asyncResult: true },
  searchShutterstockImagesAPI: { asyncResult: true },
  licenseShutterstockImageAPI: { asyncResult: true },
  getUploadedImages: { asyncResult: true },
  getImagesFromPath: { asyncResult: true },
  getGeneratedImages: { asyncResult: true },
  getHistoricImages: { asyncResult: true },
  archivePicture: { asyncResult: true },
  getImagesFromWebsite: { asyncResult: true },
  getImagesFromWebsiteAndGenerateTemplates: { asyncResult: true },
  generateCampaignAdCreativesAssets: { asyncResult: true },
  clearImageCache: { asyncResult: true },
  getTemplateImage: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Emails
  //--------------------------------------------------------------------------
  sendExternalCampaignStatus: { asyncResult: true },
  logSession: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Organizations
  //--------------------------------------------------------------------------
  fetchAllActiveOrganisations: { asyncResult: true },
  fetchAllOrganisations: { asyncResult: true },
  fetchAllUsers: { asyncResult: true },
  fetchAllNotifications: { asyncResult: true },
  loadSingleNotification: { asyncResult: true },
  createOrgaByAdmin: { asyncResult: true },
  makeUserMemberInOrga: { asyncResult: true },
  loadOrganizationOfCampaign: { asyncResult: true },
  resetCampaignList: {},
  getAllCompanies: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Comments
  //--------------------------------------------------------------------------
  fetchAllComments: { asyncResult: true },
  getNotes: { asyncResult: true },
  storeNote: { asyncResult: true },
  storeComment: { asyncResult: true },
  storeCommentWithoutEmailAndNotification: { asyncResult: true },
  deleteComment: { asyncResult: true },
  getFacebookConversation: { asyncResult: true },
  createLeadgenForm: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Reportings actions
  //--------------------------------------------------------------------------
  createReport: { asyncResult: true },
  downloadPdf: { asyncResult: true },
  downloadPreviewPdf: { asyncResult: true },
  generatePreviewImage: { asyncResult: true },
  generateReport: { asyncResult: true },

  getCampaignManager: { asyncResult: true },
  logCampaignActivity: {},
  getCampaignLogs: { asyncResult: true },
  getCampaignNotifications: { asyncResult: true },
  updateCampaignNotifications: { asyncResult: true },
  getCampaignCandidateMetrics: { asyncResult: true },
  getDailyCandidateMetrics: { asyncResult: true },
  getEmployerBrandingMetrics: { asyncResult: true },
  getPerformanceMetrics: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Admin
  //--------------------------------------------------------------------------
  //delete
  // updateTargetingGoogle: { asyncResult: true },
  getHeadlineSuggestions: { asyncResult: true },
  updateTargetingGoogleAds: { asyncResult: true },
  getApplicantsByCampaignId: { asyncResult: true },
  //--------------------------------------------------------------------------
  // ATS
  //--------------------------------------------------------------------------
  fetchAllErrorMessages: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Campaign managers
  //--------------------------------------------------------------------------
  reassignCampaignManager: { asyncResult: true },
  getAllCampaignManagers: { asyncResult: true },
  getCampaignManagerById: { asyncResult: true },
  updateCampaignManager: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Google actions
  //--------------------------------------------------------------------------
  createTwitterCampaignWithPreviewData: { asyncResult: true },
  createOnDemandGoogleDisplayCampaign: { asyncResult: true },
  createGoogleSearchCampaign: { asyncResult: true },
  //--------------------------------------------------------------------------
  // FB Pages actions
  //--------------------------------------------------------------------------
  getFacebookPagesSpend: { asyncResult: true },
  getNewFacebookPages: { asyncResult: true },
  getAllFacebookPages: { asyncResult: true },
  getFacebookPage: { asyncResult: true },
  updateFacebookPage: { asyncResult: true },
  changeFacebookPage: { asyncResult: true },
  changePageStatus: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Campaign Manager actions
  //--------------------------------------------------------------------------
  pingCSMNewCampaign: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Invoicing / Billing Related Actions
  //--------------------------------------------------------------------------
  loadInvoices: { asyncResult: true },
  sendInvoice: { asyncResult: true },
  updateCampaignInvoicePosition: { asyncResult: true },
  createInvoice: { asyncResult: true },
  getCustomerAddress: { asyncResult: true },
  archiveInvoicingOrganization: { asyncResult: true },
  createQuote: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Images
  //--------------------------------------------------------------------------
  getPageImages: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Targeting / Audience / Reach
  //--------------------------------------------------------------------------
  getSentences: { asyncResult: true },
  getAdPreviewData: { asyncResult: true },
  generateJobPage: { asyncResult: true },
  getAdGeneratedPreviews: { asyncResult: true },
  getReachEstimate: { asyncResult: true },
  queryFacebookAudiences: { asyncResult: true },
  queryFacebookAudiencesSuggestions: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Admin actions
  //--------------------------------------------------------------------------
  getKeywords: { asyncResult: true },
  getHistoricKeywordData: { asyncResult: true },
  getKeywordsJobDescription: { asyncResult: true },
  //delete
  // createGoogleDisplayCampaign: { asyncResult: true },
  createGoogleCampaign: { asyncResult: true },
  createGoogleSearchCampaignV2: { asyncResult: true },
  createSnapchatCampaign: { asyncResult: true },
  createChannelCampaigns: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Explorer Pipeline Preprocessing methods
  //-----------------------------------------------------------------------
  extractSentencesFromHTMl: { asyncResult: true },
  loadApplicantList: { asyncResult: true },
  toggleAtsView: {},
  changeApplicantField: { asyncResult: true },
  // Other data
  updateAdPreviewData: { asyncResult: true },

  // Categories
  loadJobCategories: { asyncResult: true },
  loadJobCategory: { asyncResult: true },
  //--------------------------------------------------------------------------
  // Preview
  //-----------------------------------------------------------------------
  createNewFacebookPage: { asyncResult: true },
  getTeaserTextRecommendation: { asyncResult: true },
  saveClassification: { asyncResult: true },
  saveJobCategoryLabel: { asyncResult: true },
  getJobCategory: { asyncResult: true },
  getJobCategoryWithId: { asyncResult: true },
  generateTextRecommendation: { asyncResult: true },
  updateSelectedPostNumber: {},
  updateSelectedPostData: {},
  setAdErrors: {},
  removeAdErrors: {},
  //--------------------------------------------------------------------------
  // Applicant Conversation
  //-----------------------------------------------------------------------
  sendApplicantMessage: { asyncResult: true },
  sendApplicantEmail: { asyncResult: true },
  getConversations: { asyncResult: true },
  getCampaignPerformanceMetrics: { asyncResult: true },
  getOrgaPerformanceMetrics: { asyncResult: true },
  //-----------------------------------------------------------------------
  getGoogleAdText: { asyncResult: true },
  getIndeedAdText: { asyncResult: true },
  getLinkedinAdText: { asyncResult: true },
  loadFacebookPageSpending: { asyncResult: true },
  sendMessageToCampaignManager: { asyncResult: true },
  //--------------------------------------------------------------------------
  // ATS 2.0
  //-----------------------------------------------------------------------
  getAtsData: { asyncResult: true },
  getAtsById: { asyncResult: true },
  saveQuestionsMapping: { asyncResult: true },
  getAtsDataBackend: { asyncResult: true },
  getAtsOrga: { asyncResult: true },
  updateAtsOrga: { asyncResult: true },
  getAtsTemplatesByType: { asyncResult: true },
  getFollowupQuestionTemplates: { asyncResult: true },
  newAtsCampaign: { asyncResult: true },
  sendNewAtsApplication: { asyncResult: true },
  getAllAts: { asyncResult: true },
  getAllAtsOrgas: { asyncResult: true },
  loadUser: { asyncResult: true },
  getCampaignMirror: { asyncResult: true },
  getCampaignMirrorStartAt: { asyncResult: true },
  getCampaignMirrorEndAt: { asyncResult: true },
  updateCandidateMessage: { asyncResult: true },
  getAllAtsForOrga: { asyncResult: true },
  //-----------------------------------------------------------------------
  getTargetingLayer: { asyncResult: true },
  updateJobCategory: { asyncResult: true },
  addTargetingLayerByChannel: { asyncResult: true },
  //-----------------------------------------------------------------------
  // User logs flat
  //-----------------------------------------------------------------------
  createUserLogsFlat: { asyncResult: true },
  addOrgaLog: { asyncResult: true },
  saveBudgetCheck: { asyncResult: true },
  //-----------------------------------------------------------------------
  // Segment
  //-----------------------------------------------------------------------
  trackSegmentEvent: { asyncResult: true },
  identifySegmentEvent: { asyncResult: true },
  groupSegmentEvent: { asyncResult: true },
  pageSegmentEvent: { asyncResult: true },
  //-----------------------------------------------------------------------
  // Creative Metrics
  //-----------------------------------------------------------------------
  getAggregatedCreativeMetricsByHash: { asyncResult: true },
  updateCampaignEndDate: { asyncResult: true },
  generateShareLinkForCampaign: { asyncResult: true }
};

const ApplicationActions = Reflux.createActions(INIT);
const Actions = Object.assign(
  ApplicationActions,
  SharedActions,
  ActionsDataViz,
  ActionsAdAssistant,
  ActionsJobs,
  ActionsProfile,
  ActionsCampaignsOverview,
  ActionsGlobalMediaLibrary
);

CommentSystemActions(Actions);
ActionsListeners__AtsStats(Actions, database);
ActionsListeners__System(Actions, database, auth, app, i18n);
ActionsListeners__OnlineUsers({ Actions, app });

//Brand Kit
ActionsListenersBrandKit({ Actions, auth });

// Whatsapp templates + Job form / chatbot questions
ActionsListenersConfigurations({ Actions, auth });

//Posthog
ActionsListenerPosthog({ Actions });

//DataViz
ActionsListenersDataViz({ Actions, database });

//Media Assets Lab
ActionsListenersMediaAssetsLab({ database });

//Temporary Draft Creation
ActionsListenersTempDraftCreation({ Actions, database });

//Ad Assistant
ActionsListenersAdAssistant({ Actions, database });

//Global Media Library
ActionsListenersGlobalMediaLibrary({ Actions, database });

//Jobs
ActionsListenersJobs();

// Profiles
ActionsListenersProfile();

//Campaigns Overview
ActionsListenersCampaignsOverview({ Actions, database });

window.Actions = Actions;

export function callWebUtils(context, methodName, args) {
  logger.log("Actions:callWebUtils", "Called", {
    args,
    methodName
  });
  return webAPIUtils[methodName](...args)
    .then((result) => {
      logger.debug("Actions:callWebUtils:then", "Called. result:", {
        ...result,
        methodName
      });

      if (result && result.meta && result.meta.error === true) {
        logger.debug("error:Actions:callWebUtils:then", "API endpoint threw an error", {
          result,
          methodName,
          ...args
        });
        return context?.failed(result);
      }
      if (result && result.error === true) {
        return context?.failed(result);
      }
      context?.completed(result, ...args);
    })
    .catch((err) => {
      logger.log("error:Actions:callWebUtils:catch", "Then:" + methodName, {
        err,
        methodName,
        ...args
      });
      context?.failed(err);
    });
}

// Promise version of webutils call
const webUtilsPromise = async (webUtilsMethodName, args) => {
  return new Promise((resolve, reject) => {
    callWebUtils(
      { completed: ({ payload }) => resolve(payload), failed: reject },
      webUtilsMethodName,
      args
    );
  });
};

function callSocketUtils(context, methodName, args) {
  logger.debug("Actions:callSocketUtils", "Called", {
    args,
    methodName
  });
  return socketAPIUtils[methodName](...args)
    .then((result) => {
      logger.debug("Actions:callSocketUtils:then", "Called. result:", {
        result,
        methodName,
        args
      });

      if (result && result.meta && result.meta.error === true) {
        logger.debug("error:Actions:callSocketUtils:then", "API endpoint threw an error", {
          result,
          args,
          methodName
        });
        return context.failed(result);
      }
      if (result && result.error === true) {
        return context.failed(result);
      }
      context.completed(result, ...args);
    })
    .catch((err) => {
      logger.log("error:Actions:callSocketUtils:catch", "Then:", { err, methodName, args });
      context.failed(err);
    });
}

Actions.createOnDemandGoogleDisplayCampaign.listen(function () {
  logger.log("createOnDemandGoogleDisplayCampaign", "empty");
});

//------------------------------------------------------------------------------
// Ajax-related Actions
//------------------------------------------------------------------------------
Actions.locationLookup.listen(function (locations) {
  return callWebUtils(this, "locationLookup", [locations]);
});

Actions.loadAllCampaignsAPI.listen(function () {
  return callWebUtils(this, "loadAllCampaignsAPI", []);
});

Actions.loadSingleCampaignAPI.listen(function (campaignId) {
  logger.log("Actions:loadSingleCampaignAPI", "called", { campaignId });
  return callWebUtils(this, "loadSingleCampaignAPI", [campaignId]);
});

Actions.getActivityStream.listen(function () {
  return callWebUtils(this, "getActivityStream", []);
});

Actions.getFacebookTargeting.listen(function (data) {
  return callWebUtils(this, "getFacebookTargeting", [data]);
});

Actions.queryFacebookAudiences.listen(function (query) {
  return callWebUtils(this, "queryFacebookAudiences", [query]);
});

Actions.queryFacebookAudiencesSuggestions.listen(function (targeting) {
  return callWebUtils(this, "queryFacebookAudiencesSuggestions", [targeting]);
});

Actions.getReachEstimate.listen(function (data) {
  return callWebUtils(this, "getReachEstimate", [data]);
});

Actions.sendMessageToCampaignManager.listen(function (orgaId, campaignId, params) {
  return callWebUtils(this, "sendMessageToCampaignManager", [orgaId, campaignId, params]);
});

Actions.getHistoricKeywordData.listen(function (data) {
  return callWebUtils(this, "getHistoricKeywordData", [data]);
});

Actions.getCustomerAddress.listen(function (customerId) {
  return callWebUtils(this, "getCustomerAddress", [customerId]);
});

Actions.getKeywordsJobDescription.listen(function (data) {
  return callWebUtils(this, "getKeywordsJobDescription", [data]);
});

Actions.createSnapchatCampaign.listen(function (data) {
  return callWebUtils(this, "createSnapchatCampaign", [data]);
});

Actions.createChannelCampaigns.listen(function (data) {
  return callWebUtils(this, "createChannelCampaigns", [data]);
});

Actions.copyCampaignOnChannel.listen(function (channel, socialMediaChannelId, tbCampaignId) {
  return callWebUtils(this, "copyCampaignOnChannel", [channel, socialMediaChannelId, tbCampaignId]);
});

Actions.fetchTikTokPreview.listen(function (campaignId, tikTokCampaignId) {
  return callWebUtils(this, "fetchTikTokPreview", [campaignId, tikTokCampaignId]);
});

Actions.generateVideo.listen(function (requestParams) {
  return callSocketUtils(this, "generateVideo", [requestParams]);
});
Actions.generateImage.listen(function (requestParams, templateId) {
  return callSocketUtils(this, "generateImage", [requestParams, templateId]);
});
Actions.generateMedia.listen(function (generationData) {
  return callSocketUtils(this, "generateMedia", [generationData]);
});

Actions.generateTikTokPreview.listen(function (campaignId, params) {
  logger.log("Actions:generateTikTokPreview", "called", { campaignId, params });
  return callWebUtils(this, "generateTikTokPreview", [campaignId, params]);
});

Actions.generateAudioClip.listen(function (params) {
  return callWebUtils(this, "generateAudioClip", [params]);
});

Actions.getAllJingles.listen(function () {
  return callWebUtils(this, "getAllJingles", []);
});

Actions.archiveInvoicingOrganization.listen(function ({ invoicingOrganizationId, organizationId }) {
  return callWebUtils(this, "archiveInvoicingOrganization", [
    { invoicingOrganizationId, organizationId }
  ]);
});

Actions.createQuote.listen(function (data) {
  return callWebUtils(this, "createQuote", [data]);
});

Actions.createInvoice.listen(function (orgaId, campaignId, data) {
  logger.log("Actions:sendInvoice", "called", { campaignId, ...data });
  return callWebUtils(this, "createInvoice", [orgaId, campaignId, data]);
});

Actions.loadInvoices.listen(function (orgaId) {
  return callWebUtils(this, "loadInvoices", [orgaId]);
});

Actions.sendInvoice.listen(function ({ invoiceId, organizationId, campaignId, adsetId }) {
  logger.log("Actions:sendInvoice", "called", { campaignId, invoiceId });
  return callWebUtils(this, "sendInvoice", [invoiceId, { organizationId, campaignId, adsetId }]);
});

Actions.updateCampaignInvoicePosition.listen(function (campaignId, data) {
  return callWebUtils(this, "updateCampaignInvoicePosition", [campaignId, data]);
});

Actions.getFacebookPagesSpend.listen(function (cache = "", matchTb = false) {
  return callWebUtils(this, "getFacebookPagesSpend", [cache, matchTb]);
});

Actions.getNewFacebookPages.listen(function () {
  return callWebUtils(this, "getNewFacebookPages", []);
});

Actions.getAllFacebookPages.listen(function () {
  return database.getAllFacebookPages().then(this.completed).catch(this.failed);
});

Actions.createGoogleCampaign.listen(function (data) {
  return callWebUtils(this, "createGoogleCampaign", [data]);
});

Actions.createGoogleSearchCampaignV2.listen(function (data) {
  return callWebUtils(this, "createGoogleSearchCampaignV2", [data]);
});

Actions.createGoogleSearchCampaign.listen(function (orgaId, campaignId, params) {
  logger.log("Actions:createGoogleSearchCampaign", "called", { campaignId });
  return callWebUtils(this, "createGoogleSearchCampaign", [orgaId, campaignId, params]);
});

Actions.getSentences.listen(function (jobPostingUrl, title) {
  return callWebUtils(this, "getSentences", [{ url: jobPostingUrl, title }]);
});

Actions.createNewFacebookPage.listen(function (data) {
  return callWebUtils(this, "createNewFacebookPage", [data]);
});

Actions.getTeaserTextRecommendation.listen(function (link) {
  return callWebUtils(this, "getTeaserTextRecommendation", [link]);
});

Actions.createJobTitleKeywords.listen(function (data) {
  return callWebUtils(this, "createJobTitleKeywords", [data]);
});

Actions.getKeywordsByJobTitle.listen(function ({ search }) {
  return callWebUtils(this, "getKeywordsByJobTitle", [search]);
});

Actions.getAllUserCampaignsById.listen(function (userId) {
  return callWebUtils(this, "getAllUserCampaignsById", [userId]);
});

Actions.generateTextRecommendation.listen(function ({ campaignId }) {
  return callWebUtils(this, "generateTextRecommendation", [campaignId]);
});

Actions.saveClassification.listen(function (data) {
  return callWebUtils(this, "saveClassification", [data]);
});

Actions.saveJobCategoryLabel.listen(function (data) {
  return callWebUtils(this, "saveJobCategoryLabel", [data]);
});

Actions.getJobCategory.listen(function (data) {
  return callWebUtils(this, "getJobCategory", [data]);
});

Actions.getJobCategoryWithId.listen(function (jobCategoryId) {
  return database.loadJobCategory(jobCategoryId).then(this.completed).catch(this.failed);
});

Actions.getGoogleAdText.listen(function (data) {
  return callWebUtils(this, "getGoogleAdText", [data]);
});

Actions.getIndeedAdText.listen(function (data) {
  return callWebUtils(this, "getIndeedAdText", [data]);
});

Actions.getLinkedinAdText.listen(function (data) {
  return callWebUtils(this, "getLinkedinAdText", [data]);
});

Actions.getAdPreviewData.listen(function (data) {
  return callWebUtils(this, "getAdPreviewData", [data]);
});

Actions.generateJobPage.listen(function (data) {
  return callWebUtils(this, "generateJobPage", [data]);
});

Actions.getAdGeneratedPreviews.listen(function (data) {
  return callWebUtils(this, "getAdGeneratedPreviews", [data]);
});

Actions.getKeywords.listen(function (data) {
  return callWebUtils(this, "getKeywords", [data]);
});

Actions.extractSentencesFromHTMl.listen(function (data) {
  return callWebUtils(this, "extractSentencesFromHTMl", [data]);
});

Actions.getHeadlineSuggestions.listen(function (headline) {
  return callWebUtils(this, "getHeadlineSuggestions", [headline]);
});

Actions.updateTargetingGoogleAds.listen(function (orgaId, campaignId, params) {
  return callWebUtils(this, "updateTargetingGoogleAds", [orgaId, campaignId, params]);
});
/**
 *
 * @param {Object} params
 * @param {Object} params.adsetId - TalentBait Adset Id
 * @param {Object} params.newPageId - Facebook Page Id
 * @returns
 */
Actions.changeFacebookPage.listen(function (params) {
  return callWebUtils(this, "changeFacebookPage", [params]);
});

Actions.createTwitterCampaignWithPreviewData.listen(function (data) {
  return callWebUtils(this, "createTwitterCampaignWithPreviewData", [data]);
});

Actions.pingCSMNewCampaign.listen(function (orgaId, campaignId, params) {
  return callWebUtils(this, "pingCSMNewCampaign", [orgaId, campaignId, params]);
});

Actions.reassignCampaignManager.listen(function (campaignId, params) {
  logger.log("Actions:reassignCampaignManager", "called", { campaignId, params });
  return callWebUtils(this, "reassignCampaignManager", [campaignId, params]);
});

Actions.getFacebookConversation.listen(function (data) {
  return callWebUtils(this, "getFacebookConversation", [data]);
});

Actions.createLeadgenForm.listen(function (data) {
  return callWebUtils(this, "createLeadgenForm", [data]);
});

Actions.sendApplicantMessage.listen(function (data) {
  return callWebUtils(this, "sendApplicantMessage", [data]);
});

Actions.sendApplicantEmail.listen(function (data) {
  return callWebUtils(this, "sendApplicantEmail", [data]);
});

Actions.getConversations.listen(function (data) {
  return callWebUtils(this, "getConversations", [data]);
});

Actions.downloadPdf.listen(async function ({ campaignId, orgaId, campaignGoal, publicPDFUrl }) {
  logger.log("Actions:downloadPdf", "called", { campaignId });
  const organization = await database.findOrganizationById(orgaId);
  const { showCreativeTable } = organization;
  return callWebUtils(this, "generateReport", [
    campaignId,
    orgaId,
    campaignGoal,
    publicPDFUrl,
    showCreativeTable
  ]);
});

Actions.downloadPreviewPdf.listen(function (campaignId, channel, data) {
  logger.log("Actions:downloadPreviewPdf", "called", { campaignId });
  return callWebUtils(this, "downloadPreviewPdf", [campaignId, channel, data]);
});

Actions.generatePreviewImage.listen(function (campaignId, data) {
  return callWebUtils(this, "generatePreviewImage", [campaignId, data]);
});

Actions.searchStockImage.listen(function (searchTerm) {
  return callWebUtils(this, "searchStockImage", [{ search: searchTerm }]);
});

Actions.searchShutterstockImagesAPI.listen(async function (query) {
  const { fallbackSearch, version } = query;
  const userProfile = query.userProfile ?? { userName: "System" };
  const cleanQuery = {
    ...query,
    userProfile: undefined,
    fallbackSearch: undefined,
    version: undefined
  };
  let didFallback = false;

  if (!userProfile.userName) userProfile.userName = "System";
  logger.log("Actions:searchShutterstockImagesAPI", "has been called with", { query });

  try {
    const endpoint =
      version === SHUTTERSTOCK_API_VERSION
        ? "searchShutterstockImagesAPIv2"
        : "searchShutterstockImagesAPI";

    const payload = await webUtilsPromise(endpoint, [cleanQuery]);

    logger.log("Actions:searchShutterstockImagesAPI", "API returned images result", payload);
    const images = payload.data;

    if (images.length <= 0) {
      sendSearchNoResultsMessageToSlack({ query: query.search, userProfile });
    }

    if (images.length <= 0 && fallbackSearch) {
      const newQuery = { ...cleanQuery, search: fallbackSearch };
      logger.log("Actions:searchShutterstockImagesAPI", "Calling with fallback search", {
        fallbackSearch
      });

      sendSearchFallbackMessageToSlack({ query: query.search, fallbackSearch, userProfile });
      const payload = await webUtilsPromise(endpoint, [newQuery]);
      didFallback = true;

      logger.log(
        "Actions:searchShutterstockImagesAPI",
        "API returned images result from fallback search",
        payload
      );

      payload.fallback = didFallback;

      return this?.completed({ payload, query });
    }

    payload.fallback = didFallback;

    this?.completed({ payload, query });
  } catch (error) {
    logger.log("Actions:searchShutterstockImagesAPI", "Image fetching failed", error);

    sendSearchErrorMessageToSlack({
      error: error?.meta?.message || "Unable to fetch stock pictures",
      query: query.search,
      userProfile
    });

    error.search = query.search;
    error.fallbackSearch = fallbackSearch;
    error.fallback = didFallback;
    error.userProfile = userProfile;

    this?.failed(error);
  }
});

function sendSearchFallbackMessageToSlack({ query, fallbackSearch, userProfile }) {
  const message =
    ":warning: Using fallback search to search shutterstock images" +
    "\n\n" +
    `>User: ${userProfile.userName}` +
    "\n" +
    `>Fallback query search: \`${fallbackSearch}\``;
  "\n" + `>Query: \`${query}\``;
  return callWebUtils(this, "sendSlack", [{ text: message, channel: "comments" }]);
}

function sendSearchErrorMessageToSlack({ error, query, userProfile }) {
  const message =
    ":warning: There was an error fetching images from shutterstock." +
    "\n\n" +
    `>User: ${userProfile.userName}` +
    "\n" +
    `>Error message: \`${error.message}\`` +
    "\n" +
    `>Query: \`${query}\``;
  return callWebUtils(this, "sendSlack", [{ text: message, channel: "comments" }]);
}

function sendSearchNoResultsMessageToSlack({ query, userProfile }) {
  const message =
    ":warning: Got no results from shutterstock images search" +
    "\n\n" +
    `>User: ${userProfile.userName}` +
    "\n" +
    `>Query: \`${query}\``;
  return callWebUtils(this, "sendSlack", [{ text: message, channel: "comments" }]);
}

Actions.searchShutterstockAssets.listen(async function (search) {
  return callWebUtils(this, "searchShutterstockAssets", [search]);
});

Actions.licenseShutterstockImageAPI.listen(function (body) {
  return callWebUtils(this, "licenseShutterstockImageAPI", [body]);
});

Actions.getUploadedImages.listen(function (orgaName, companyName, orgaId, campaignId) {
  logger.log("Actions:getUploadedImages", "called", { orgaName, companyName, orgaId, campaignId });
  return callWebUtils(this, "getUploadedImages", [{ orgaName, companyName, orgaId, campaignId }]);
});

Actions.getImagesFromPath.listen(function (path) {
  logger.log("Actions:getImagesFromPath", "called", { path });
  return callWebUtils(this, "getImagesFromPath", [{ path }]);
});

Actions.getGeneratedImages.listen(function (folderName) {
  logger.log("Actions:getGeneratedImages", "called", { folderName });
  return callWebUtils(this, "getImagesFromPath", [{ path: folderName }]);
});

Actions.getHistoricImages.listen(function ({
  companyName,
  orgaId,
  orgaName,
  offset,
  cursor,
  companyId
}) {
  return callWebUtils(this, "getHistoricImages", [
    { companyName, orgaId, orgaName, offset, cursor, companyId }
  ]);
});

Actions.archivePicture.listen(function ({ orgaId, campaignId, url, source }) {
  return callWebUtils(this, "archivePicture", [{ orgaId, campaignId, url, source }]);
});

Actions.getImagesFromWebsite.listen(function (jobPostingUrl, orgaName, companyName, orgaId) {
  logger.log("Actions:getImagesFromWebsite", "called", {
    jobPostingUrl,
    orgaName,
    companyName,
    orgaId
  });
  return callWebUtils(this, "getImagesFromWebsite", [
    {
      url: jobPostingUrl,
      orgaName,
      companyName,
      orgaId
    }
  ]);
});

Actions.uploadMedia.listen(function (uploadMediaData) {
  logger.log("Actions:uploadMedia", "called", { uploadMediaData });
  return callWebUtils(this, "uploadMedia", [uploadMediaData]);
});

Actions.clearImageCache.listen(function () {
  return callWebUtils(this, "clearImageCache", []);
});

Actions.getTemplateImage.listen(function (templateData) {
  return callWebUtils(this, "getTemplateImage", [templateData]);
});

Actions.loadClickMetricsByDay.listen(function (orgaId, campaignId, datePreset) {
  return callWebUtils(this, "metricsByDay", [orgaId, campaignId, datePreset]);
});

Actions.sendExternalCampaignStatus.listen((campaignId, newStatus) => {
  logger.log("Actions:sendExternalCampaignStatus", "called", { campaignId, newStatus });
  return callWebUtils(this, "sendExternalCampaignStatus", [campaignId, newStatus]);
});

Actions.validateCampaignCoupon.listen(function ({ couponCode, campaignId, campaignData }) {
  return callWebUtils(this, "validateCampaignCoupon", [couponCode, campaignId, campaignData]);
});

Actions.getPrepaidTransactions.listen(function (organizationId) {
  return callWebUtils(this, "getPrepaidTransactions", [organizationId]);
});

Actions.getPrepaidBalance.listen(function (organizationId) {
  return callWebUtils(this, "getPrepaidBalance", [organizationId]);
});

Actions.getPrepaidPackages.listen(function () {
  return callWebUtils(this, "getPrepaidPackages", []);
});

Actions.topUpPrepaidMoney.listen(function ({ organizationId, packageId, invoicing }) {
  return callWebUtils(this, "topUpPrepaidMoney", [{ organizationId, packageId, invoicing }]);
});

Actions.setCampaignLive.listen(function (
  campaignId,
  adsetId,
  channelGroupsToSetLive,
  meta,
  waitForChannels,
  shutterstockFlag
) {
  logger.log("Actions:setCampaignLive", "called", { campaignId, adsetId, channelGroupsToSetLive });
  return callWebUtils(this, "setCampaignLive", [
    campaignId,
    adsetId,
    channelGroupsToSetLive,
    meta,
    waitForChannels,
    shutterstockFlag
  ]);
});
Actions.createCampaignsOnChannels.listen(function (
  campaignId,
  adsetId,
  groupsToCreate,
  orgaId,
  channels,
  userName,
  shutterstockFlag
) {
  logger.log("Actions:createCampaignsOnChannels", "called", { campaignId, adsetId });
  return callWebUtils(this, "createCampaignsOnChannels", [
    campaignId,
    adsetId,
    groupsToCreate,
    orgaId,
    channels,
    userName,
    shutterstockFlag
  ]);
});

Actions.createCampaignAndSave.listen(function (orgaId, data, adPreviewData, adpreview) {
  logger.log("Actions:createCampaignAndSave", "called", { orgaId, data, adPreviewData, adpreview });
  return callWebUtils(this, "createTalentBaitCampaign", [orgaId, data, adPreviewData, adpreview]);
});

Actions.createCampaignAndSaveWithId.listen(function (
  orgaId,
  data,
  adPreviewData,
  adpreview,
  campaignId
) {
  logger.log("Actions:createCampaignAndSaveWithId", "called", {
    orgaId,
    data,
    adPreviewData,
    adpreview,
    campaignId
  });
  return callWebUtils(this, "createTalentBaitCampaignWithId", [
    orgaId,
    data,
    adPreviewData,
    adpreview,
    campaignId
  ]);
});

Actions.createInitialAdsetAndChannelCampaignsForCampaign.listen(function (campaignId) {
  logger.log("Actions:createInitialAdsetAndChannelCampaignsForCampaign", "called", { campaignId });
  return callWebUtils(this, "createInitialAdsetAndChannelCampaignsForCampaign", [campaignId]);
});

Actions.extendCampaign.listen(function (campaignId, data) {
  return callWebUtils(this, "extendCampaign", [campaignId, data]);
});

Actions.extendCampaignDate.listen(function ({ campaignId, daysToExtend }) {
  logger.log("Actions:extendCampaignDate", "was called with", { campaignId, daysToExtend });
  return callWebUtils(this, "extendCampaignDate", [{ campaignId, daysToExtend }]);
});

// Responsible for updating campaign status in all Ads platforms
Actions.updateCampaignStatus.listen(function (campaignId, newStatus, userName, notify = true) {
  logger.log("Actions:updateCampaignStatus", "called", {
    campaignId,
    newStatus,
    userName
  });
  return callWebUtils(this, "updateTalentBaitCampaignStatus", [
    campaignId,
    newStatus,
    userName,
    notify
  ]);
});

// Responsible to triggering a schedule task on the Google Cloud Queue
Actions.triggerAutomaticCampaignReportTask(function (campaignId, time) {
  logger.log("Actions:triggerAutomaticCampaignReportTask", "called", { campaignId, time });
  return callWebUtils(this, "triggerAutomaticCampaignReportTask", [campaignId, time]);
});

Actions.toggleAdsetChannels.listen(function (adsetId, channelsToToggle) {
  return callWebUtils(this, "toggleAdsetChannels", [adsetId, channelsToToggle]);
});

Actions.recalculateChannelCampaignsBudgets.listen(function (adsetId) {
  return callWebUtils(this, "recalculateChannelCampaignsBudgets", [adsetId]);
});

Actions.createPlatformsChannelCampaignsOnAdset.listen(function (adsetId, channels) {
  return callWebUtils(this, "createPlatformsChannelCampaignsOnAdset", [adsetId, channels]);
});

Actions.deleteChannelCampaignById.listen(function (channelCampaignId) {
  return callWebUtils(this, "deleteChannelCampaignById", [channelCampaignId]);
});

Actions.sendSlack.listen(function (text, channel, meta) {
  return callWebUtils(this, "sendSlack", [{ text, channel, meta }]);
});

Actions.createReport.listen(function (campaignId, campaignData) {
  logger.log("Actions:createReport", "called", { campaignId });
  return callWebUtils(this, "createReport", [campaignId, campaignData]);
});

Actions.logSession.listen(function (user) {
  return callWebUtils(this, "newSession", [user]);
});

Actions.getAtsDataBackend.listen(function (campaignId, platform) {
  return callWebUtils(this, "getAtsDataBackend", [campaignId, platform]);
});

Actions.changeFacebookCampaign.listen(function (campaignId, params) {
  return callWebUtils(this, "changeFacebookCampaign", [campaignId, params]);
});

Actions.changeFacebookAdset.listen(function (campaignId, params) {
  return callWebUtils(this, "changeFacebookAdset", [campaignId, params]);
});

Actions.changeFacebookAdsetEndDate.listen(function (campaignId, params) {
  logger.log("Actions:changeFacebookAdsetEndDate", "called", { campaignId, params });
  return callWebUtils(this, "changeFacebookAdsetEndDate", [campaignId, params]);
});

Actions.changeFacebookCampaignAdsetsAndAdsField.listen(function (campaignId, params) {
  logger.log("Actions:changeFacebookAdsetEndDate", "called", { campaignId, params });
  return callWebUtils(this, "changeFacebookCampaignAdsetsAndAdsField", [campaignId, params]);
});

Actions.updatePlatformCampaignsEndDates.listen(function ({ tbCampaignId, newEndDate }) {
  logger.log("Actions:updatePlatformCampaignsEndDates", "called", {
    campaignId: tbCampaignId,
    newEndDate
  });
  return callWebUtils(this, "updatePlatformCampaignsEndDates", [{ tbCampaignId, newEndDate }]);
});

Actions.updateDestinationLink.listen(function (tbCampaignId, tbAdsetId, updates) {
  logger.log("Actions:updateDestinationLink", "called", {
    campaignId: tbCampaignId,
    tbAdsetId,
    updates
  });
  return callWebUtils(this, "updateDestinationLink", [tbCampaignId, tbAdsetId, updates]);
});

Actions.getCampaignManager.listen(function () {
  return callWebUtils(this, "getCampaignManager", []);
});

Actions.getPlacements.listen(function (jobTitle, jobCategory) {
  logger.log("Actions:getPlacements", "called", { jobTitle, jobCategory });
  return callWebUtils(this, "getPlacements", [jobTitle, jobCategory]);
});

// Google placements
Actions.getGooglePlacements.listen(function (adwordsCampaignId) {
  logger.log("Actions:getGooglePlacements", "called", { adwordsCampaignId });
  return callWebUtils(this, "getGooglePlacements", [adwordsCampaignId]);
});

Actions.removeGooglePlacements.listen(function (placementId, label) {
  logger.log("Actions:removeGooglePlacements", "called", { placementId, label });
  return callWebUtils(this, "removeGooglePlacements", [placementId, label]);
});

Actions.loadCampaignDataPublic.listen(function (campaignId) {
  logger.log("Actions:loadCampaignDataPublic", "called", { campaignId });
  return callWebUtils(this, "loadCampaignDataPublic", [campaignId]);
});

Actions.loadAdsetDataPublic.listen(function (adsetId) {
  return callWebUtils(this, "loadAdsetDataPublic", [adsetId]);
});

Actions.sendLiveLink.listen(function (orgaId, campaignId, data) {
  return callWebUtils(this, "sendLiveLink", [orgaId, campaignId, data]);
});

Actions.getPersonioJobs.listen(function (data) {
  return callWebUtils(this, "getPersonioJobs", [data]);
});

Actions.getRecruiteeJobs.listen(function (data) {
  return callWebUtils(this, "getRecruiteeJobs", [data]);
});

Actions.getRecruiteeJobById.listen(function (jobId, orgaId) {
  return callWebUtils(this, "getRecruiteeJobById", [jobId, orgaId]);
});
//--------------------------------------------------------------------------------
// DATABASE RELATED ACTION
//--------------------------------------------------------------------------------

Actions.getTargetingLayer.listen(function (startAfter, limit, nameFilter = "") {
  database.getTargetingLayer(startAfter, limit, nameFilter).then(this.completed).catch(this.failed);
});

Actions.updateJobCategory.listen(function (id, data) {
  database.updateJobCategory(id, data).then(this.completed).catch(this.failed);
});

Actions.addTargetingLayerByChannel.listen(function (id, channelFieldName, data) {
  database
    .addTargetingLayerByChannel(id, channelFieldName, data)
    .then(this.completed)
    .catch(this.failed);
});

Actions.makeUserMemberInOrga.listen(function (orgaId, orgaName, userId) {
  return database
    .makeUserMemberInOrga(orgaId, orgaName, userId)
    .then(this.completed)
    .catch(this.failed);
});

Actions.loadPackagesByOrga.listen(function (orgaId) {
  return database.loadPackagesByOrga(orgaId).then(this.completed).catch(this.failed);
});

Actions.addPackagesToOrga.listen(function (newPackage) {
  return database.addPackagesToOrga(newPackage).then(this.completed).catch(this.failed);
});

Actions.removePackage.listen(function (packageId) {
  return database.removePackage(packageId).then(this.completed).catch(this.failed);
});

Actions.fetchAllErrorMessages.listen(function () {
  return database.fetchAllErrorMessages().then(this.completed).catch(this.failed);
});

Actions.getNotes.listen(function (orgaId, campaignId) {
  return database.getNotes(orgaId, campaignId).then(this.completed).catch(this.failed);
});

Actions.storeNote.listen(function (note) {
  return database.storeNote(note).then(this.completed).catch(this.failed);
});

Actions.editPackage.listen(function (packageId, data) {
  return database.editPackage(packageId, data).then(this.completed).catch(this.failed);
});

Actions.getAllComments.listen(function (userId) {
  return database.getAllComments(userId).then(this.completed).catch(this.failed);
});

Actions.getCampaignPerformanceMetrics.listen(function (campaignId) {
  database
    .getCampaignWithId(campaignId)
    .then((campaign) => {
      logger.log("Actions:getCampaignPerformanceMetrics", "Got campaign by id", {
        campaignId
      });
      const { avgReactionTimeMin } = campaign;
      const performanceMetrics = {
        avgReactionTimeMin: avgReactionTimeMin == 0 ? null : avgReactionTimeMin
      };
      this.completed(performanceMetrics);
    })
    .catch(this.failed);
});

Actions.getOrgaPerformanceMetrics.listen(function (orgaId) {
  database
    .getAtsOrga(orgaId)
    .then((ats) => {
      logger.log("Actions:getOrgaPerformanceMetrics", "get orga by id", {
        orgaId,
        ats
      });
      this.completed(ats);
    })
    .catch(this.failed);
});

Actions.copyCampaign.listen(function (campaignId, newUserId, newUserName) {
  return database
    .copyCampaign(campaignId, newUserId, newUserName)
    .then(this.completed)
    .catch(this.failed);
});

Actions.duplicateCampaign.listen(function (campaignId, newUserId, newUserName) {
  logger.log("Actions:duplicateCampaign", "called", { campaignId, newUserId, newUserName });
  return database
    .duplicateCampaign(campaignId, newUserId, newUserName)
    .then(this.completed)
    .catch(this.failed);
});

Actions.copyAdCreatives.listen(function ({
  sourceCampaignId,
  targetCampaignId,
  campaignGoal,
  channelCampaignIds,
  adsetId,
  jobCategoryId,
  orgaId
}) {
  logger.log("Actions:copyAdCreatives", "called", {
    campaignId: sourceCampaignId,
    sourceCampaignId,
    targetCampaignId
  });
  return database
    .copyAdCreatives({
      sourceCampaignId,
      targetCampaignId,
      campaignGoal,
      channelCampaignIds,
      adsetId,
      jobCategoryId,
      orgaId
    })
    .then(this.completed)
    .catch(this.failed);
});

Actions.copyCampaignATSSettings.listen(function (campaignId, newCampaignId) {
  logger.log("Actions:copyCampaignATSSettings", "called", { campaignId, newCampaignId });
  return database
    .copyCampaignATSSettings(campaignId, newCampaignId)
    .then(this.completed)
    .catch(this.failed);
});

Actions.copyCampaignMembers.listen(function (campaignId, newCampaignId) {
  logger.log("Actions:copyCampaignMembers", "called", { campaignId, newCampaignId });
  return database
    .copyCampaignMembers(campaignId, newCampaignId)
    .then(this.completed)
    .catch(this.failed);
});

Actions.updateCampaignMembers.listen(function (campaignId, campaignMembers) {
  logger.log("Actions:updateCampaignMembers", "called", { campaignId, campaignMembers });
  return callWebUtils(this, "updateCampaignMembers", [
    campaignId,
    { memberUpdates: campaignMembers }
  ]);
});

Actions.updateUser.listen(function (userId, data) {
  return callWebUtils(this, "updateUser", [userId, data]);
});

Actions.moveCampaignATSSettings.listen(function (campaignId, newCampaignId) {
  logger.log("Actions:moveCampaignATSSettings", "called", { campaignId, newCampaignId });
  return database
    .moveCampaignATSSettings(campaignId, newCampaignId)
    .then(this.completed)
    .catch(this.failed);
});

Actions.updateCandidatesByCampaignId.listen(function (data) {
  return callWebUtils(this, "updateCandidatesByCampaignId", [data]);
});

Actions.getFacebookPage.listen(function (pageId) {
  return database.getFacebookPage(pageId).then(this.completed).catch(this.failed);
});

Actions.getAllAtsForOrga.listen(function (orgaId) {
  return database.getAllAtsForOrga(orgaId).then(this.completed).catch(this.failed);
});

Actions.updateFacebookPage.listen(function (pageId, data) {
  return database.updateFacebookPage(pageId, data).then(this.completed).catch(this.failed);
});

Actions.getCampaignLogs.listen(function (campaignId) {
  return database.getCampaignLogs(campaignId).then(this.completed).catch(this.failed);
});

Actions.getCampaignNotifications.listen(function (campaignId) {
  return database.getCampaignNotifications(campaignId).then(this.completed).catch(this.failed);
});

Actions.updateCampaignNotifications.listen(function (notificationId, notificationData) {
  return database
    .updateCampaignNotifications(notificationId, notificationData)
    .then(this.completed)
    .catch(this.failed);
});

Actions.logCampaignActivity.listen(function (campaignId, data) {
  return database.addCampaignLog(campaignId, data).then(this.completed).catch(this.failed);
});

Actions.loadDailyClicks.listen(function (campaignId) {
  return database.loadDailyClicks(campaignId).then(this.completed).catch(this.failed);
});

Actions.loadJobCategories.listen(function () {
  return database.loadJobCategories().then(this.completed).catch(this.failed);
});

Actions.loadJobCategory.listen(function (jobCategoryId) {
  return database.loadJobCategory(jobCategoryId).then(this.completed).catch(this.failed);
});

Actions.getCampaignsWithCondition.listen(function (field, operator, value) {
  database
    .getCampaignsWithCondition(field, operator, value)
    .then(this.completed)
    .catch(this.failed);
});

Actions.loadAllHistoricCampaigns.listen(function () {
  database.loadAllHistoricCampaigns().then(this.completed).catch(this.failed);
});

Actions.loadAllActiveCampaigns.listen(function () {
  database.loadAllActiveCampaigns().then(this.completed).catch(this.failed);
});

Actions.getApplicantsByCampaignId.listen(function (campaignId) {
  logger.log("Actions:getApplicantsByCampaignId", "called...", { campaignId });
  database.getApplicantsByCampaignId(campaignId).then(this.completed).catch(this.failed);
});

Actions.loadCampaignsByStatusCriteria.listen(function (statusList) {
  database.loadCampaignsByStatusCriteria(statusList).then(this.completed).catch(this.failed);
});

Actions.loadAdsets.listen(function (campaignId) {
  logger.log("Actions:loadAdsets", "called...", { campaignId });
  database.loadAdsets(campaignId).then(this.completed).catch(this.failed);
});

Actions.loadAdset.listen(function (adsetId) {
  database.loadAdset(adsetId).then(this.completed).catch(this.failed);
});

Actions.updateAdset.listen(function (adsetId, data) {
  database.updateAdset(adsetId, data).then(this.completed).catch(this.failed);
});

Actions.lastNCampaignsQuery.listen(function (last) {
  database.lastNCampaignsQuery(last).then(this.completed).catch(this.failed);
});

Actions.loadAllHistoryCampaigns.listen(function () {
  database.loadAllHistoryCampaigns().then(this.completed).catch(this.failed);
});

Actions.addChannelDataToCampaign.listen(function (tbCampaignId, idOnChannel, channelName) {
  logger.log("Actions:addChannelDataToCampaign", "called...", { campaignId: tbCampaignId });
  database.addChannelDataToCampaign(tbCampaignId, {
    campaignId: idOnChannel,
    platform: channelName,
    active: true
  });
});

Actions.loadUser.listen(function (userId) {
  logger.log("Actions:loadUser", "called...", { userId });

  database
    .getUserDataWithId(userId)
    .then((snapshot) => {
      logger.log("Actions:loadUser", "then", { userId });
      const userData = snapshot.data();
      this.completed(userData, userId);
    })
    .catch(this.failed);
});

Actions.getCampaignMirror.listen(function (page, channels, order) {
  database.getCampaignMirror(page, channels, order).then(this.completed).catch(this.failed);
});

Actions.getCampaignMirrorStartAt.listen(function (startAt, page, channels, order) {
  database
    .getCampaignMirrorStartAt(startAt, page, channels, order)
    .then(this.completed)
    .catch(this.failed);
});

Actions.getCampaignMirrorEndAt.listen(function (endAt, page, channels, order) {
  database
    .getCampaignMirrorEndAt(endAt, page, channels, order)
    .then(this.completed)
    .catch(this.failed);
});

Actions.getSocialComments.listen(function (campaignId) {
  logger.log("Actions:getSocialComments", "called...", { campaignId });
  database.getSocialComments(campaignId).then(this.completed).catch(this.failed);
});

Actions.getSocialCommentsCount.listen(function (campaignId) {
  logger.log("Actions:getSocialCommentsCount", "called...", { campaignId });
  database.getSocialCommentsCount(campaignId).then(this.completed).catch(this.failed);
});

Actions.getAtsData.listen(function (campaignId) {
  logger.log("Actions:getAtsData", "called...", { campaignId });
  database.getSingleEntry("ats", campaignId).then(this.completed).catch(this.failed);
});

Actions.getAtsById.listen(function (campaignId) {
  logger.log("Actions:getAtsById", "getAtsById called", { campaignId });
  return callWebUtils(this, "getAtsById", [campaignId]);
});

Actions.saveQuestionsMapping.listen(function (campaignId, questionsMapping) {
  logger.log("Actions:saveQuestionsMapping", "saveQuestionsMapping called", { campaignId });
  return callWebUtils(this, "saveQuestionsMapping", [campaignId, questionsMapping]);
});

Actions.getAtsOrga.listen(function (orgaId, lng) {
  database
    .getAtsOrga(orgaId)
    .then((data) => this.completed(data, lng))
    .catch(this.failed);
});

Actions.updateAtsOrga.listen(function (orgaId, data) {
  logger.log("Actions:updateAtsOrga", "called...", { orgaId, data });
  database.updateSingleEntry("ats_orga", orgaId, data).then(this.completed).catch(this.failed);
});

Actions.getFollowupQuestionTemplates.listen(async function (orgaId) {
  try {
    const defaultTemplates = await database.getMessageTemplateByTypeAndOrga(
      "followup_question",
      null
    );
    const orgaTemplates = await database.getMessageTemplateByTypeAndOrga(
      "followup_question",
      orgaId
    );

    const allTemplates = [...defaultTemplates, ...orgaTemplates];

    logger.log("Actions:getFollowupQuestionTemplates", "allTemplates", {
      allTemplates,
      orgaId
    });

    this.completed(allTemplates, orgaId);
  } catch (error) {
    logger.error("Actions:getFollowupQuestionTemplates", "error", {
      error,
      orgaId
    });
    this.failed(error);
  }
});

Actions.getAtsTemplatesByType.listen(function (type) {
  database
    .getAtsTemplatesByType(type)
    .then((data) => this.completed(data, type))
    .catch(this.failed);
});

Actions.updateCandidateMessage.listen(function (messageId, data) {
  logger.log("Actions:updateCandidateMessage", "called...", { messageId, data });
  database.updateSingleEntry("messages", messageId, data).then(this.completed).catch(this.failed);
});

Actions.changePageStatus.listen(function (pageId, data) {
  logger.log("Actions:changePageStatus", "called...", { pageId, data });
  database
    .updateSingleEntry("social_accounts", pageId, data)
    .then(this.completed)
    .catch(this.failed);
});

Actions.getAssets.listen(function (assetIds) {
  logger.log("Actions:getAssets", "called...", { assetIds });
  return callWebUtils(this, "getAssets", [assetIds]);
});
Actions.getAssetsPhotoEditor.listen(function (assetIds) {
  logger.log("Actions:getAssetsPhotoEditor", "called...", { assetIds });
  return callWebUtils(this, "getAssets", [assetIds]);
});
Actions.getAssetsPerformanceEditor.listen(function (assetIds) {
  logger.log("Actions:getAssetsPerformanceEditor", "called...", { assetIds });
  return callWebUtils(this, "getAssets", [assetIds]);
});
Actions.saveAssets.listen(function (orgaId, companyId, data) {
  logger.log("Actions:saveAssets", "called...", { orgaId, companyId, data });
  return callWebUtils(this, "saveAssets", [orgaId, companyId, data]);
});
Actions.deleteCreativeAsset.listen(function (adCreativeId, data) {
  logger.log("Actions:deleteCreativeAsset", "called...", { adCreativeId, data });
  return callWebUtils(this, "deleteCreativeAsset", [adCreativeId, data]);
});

Actions.saveAdCreative.listen(function (data) {
  logger.log("Actions:saveAdCreative", "called...", { data });
  return callWebUtils(this, "createAdCreative", [data]);
});
Actions.saveAdCreatives.listen(function (creatives, campaignId) {
  logger.log("Actions:saveAdCreatives", "called...", { campaignId, creatives });
  database.saveAdCreatives(creatives).then(this.completed).catch(this.failed);
});
Actions.deleteAdCreativesByCampaignId.listen(function (campaignId) {
  logger.log("Actions:deleteAdCreativesByCampaignId", "called...", { campaignId });
  return callWebUtils(this, "deleteAdCreativesByCampaignId", [campaignId]);
});
Actions.updateAdCreative.listen(function (adCreativeId, data) {
  logger.log("Actions:updateAdCreative", "called...", { adCreativeId, data });
  return callWebUtils(this, "updateAdCreative", [adCreativeId, data]);
});
Actions.updateAdCreatives.listen(function (creatives) {
  logger.log("Actions:updateAdCreatives", "called...", { creatives });
  database.updateAdCreatives(creatives).then(this.completed).catch(this.failed);
});
Actions.deleteAdCreatives.listen(function (creativeIds) {
  logger.log("Actions:deleteAdCreatives", "called...", { creativeIds });
  database.deleteAdCreatives(creativeIds).then(this.completed).catch(this.failed);
});
Actions.getAdCreativesByCampaignId.listen(function (campaignId) {
  logger.log("Actions:getAdCreativesByCampaignId", "called...", { campaignId });
  return database.getAdCreativesByCampaignId(campaignId).then(this.completed).catch(this.failed);
});
Actions.getAdCreativesByCampaignIdAndChannel.listen(function (campaignId, channel) {
  logger.log("Actions:getAdCreativesByCampaignIdAndChannel", "called...", { campaignId, channel });
  database
    .getAdCreativesByCampaignIdAndChannel(campaignId, channel)
    .then(this.completed)
    .catch(this.failed);
});
Actions.getLastLinkedInAdCreativesByCompanyAndOrgaId.listen(async function (companyName, orgaId) {
  logger.log("Actions:getLastLinkedInAdCreativesByCompanyAndOrgaId", "called...", {
    companyName,
    orgaId
  });

  return await database
    .getLastLinkedInAdCreativesByCompanyAndOrgaId(companyName, orgaId)
    .then(this.completed)
    .catch(this.failed);
});
Actions.getChannelCampaignsByAdsetId.listen((adsetId) => {
  logger.debug("Actions:getChannelCampaignsByAdsetId", "called...", { adsetId });
  database.getChannelCampaignsByAdsetId(adsetId).then(this.completed).catch(this.failed);
});
Actions.updateChannelCampaign.listen((channelCampaignId, data) => {
  logger.debug("Actions:updateChannelCampaign", "called...", { channelCampaignId, data });
  database.updateChannelCampaign(channelCampaignId, data).then(this?.completed).catch(this?.failed);
});

Actions.newAtsCampaign.listen(function (campaignId, data = {}) {
  return callWebUtils(this, "postEndpointWithoutToken", [
    config.updateWebhooksUrl + "/new-lead-campaign",
    { campaignId, atsObject: data },
    {}
  ]);
});

Actions.sendNewAtsApplication.listen(function (campaignId, data) {
  return callWebUtils(this, "postEndpointWithoutToken", [
    config.updateWebhooksUrl + "/web_lead",
    { campaignId, ...data }
  ]);
});
//--------------------------------------------------------------------------------
// DATABASE RELATED ACTION with more logic
//--------------------------------------------------------------------------------
Actions.loadSingleCampaign.listen(function (campaignId) {
  database
    .getCampaignWithId(campaignId)
    .then((campaignData) => {
      if (!campaignData) {
        logger.log("error:Actions:loadSingleCampaign", "No campaignData found", {
          campaignData,
          campaignId
        });
        return this.failed("Campaign data empty");
      }
      // We need to add the campaignId here, its not contained in the result
      this.completed(_.extend({}, campaignData, { id: campaignId }));
    })
    .catch(this.failed);
});

Actions.loadSharedCampaignData.listen(function (campaignId, token) {
  logger.log("Actions:loadSharedCampaignData", "called", { campaignId });
  return callWebUtils(this, "loadSharedCampaignData", [campaignId, token]);
});

Actions.getAdsetsByCampaignId.listen(function (campaignId) {
  logger.log("Actions:getAdsetsByCampaignId", "called", { campaignId });
  database
    .getAdsetsByCampaignId(campaignId)
    .then((adsets) => {
      if (!adsets) {
        logger.log("error:Actions:getAdsetsByCampaignId", "No adsets found", {
          adsets,
          campaignId
        });
        return this.failed("Campaign data empty");
      }
      logger.debug("Actions:getAdsetsByCampaignId", "finished", { adsets });
      this.completed(adsets);
    })
    .catch(this.failed);
});
Actions.getAdsetsByCampaignIdPublic.listen(function (campaignId) {
  logger.log("Actions:getAdsetsByCampaignIdPublic", "called", { campaignId });
  return callWebUtils(this, "getAdsetsByCampaignIdPublic", [campaignId]);
});
Actions.getAdsetById.listen(function (adsetId) {
  logger.log("Actions:getAdsetById", "called", { adsetId });
  database
    .getAdsetById(adsetId)
    .then((adset) => {
      if (!adset) {
        logger.log("error:Actions:getAdsetById", "No adset found", {
          adset,
          adsetId
        });
        return this.failed("No adset found");
      }
      logger.log("Actions:getAdsetById", "finished", { adset });
      this.completed(adset);
    })
    .catch(this.failed);
});
Actions.getChannelCampaignsByCampaignId.listen(function (campaignId, orgaId) {
  logger.log("Actions:getChannelCampaignsByCampaignId", "Start getting channel campaign IDs", {
    campaignId,
    orgaId
  });

  if (orgaId) {
    database
      .getChannelCampaignsByCampaignIdAndOrgaId(campaignId, orgaId)
      .then((channelCampagins) => {
        if (!channelCampagins) {
          logger.log("error:Actions:getChannelCampaignsByCampaignId", "No channelCampagins found", {
            channelCampagins,
            campaignId
          });
          return this.failed("Campaign data empty");
        }
        logger.log("Actions:getChannelCampaignsByCampaignId", "finished", {
          channelCampagins,
          campaignId
        });
        this.completed(channelCampagins);
      })
      .catch((error) => {
        this.failed(error);
      });
  } else {
    database
      .getChannelCampaignsByCampaignId(campaignId)
      .then((channelCampagins) => {
        if (!channelCampagins) {
          logger.log("error:Actions:getChannelCampaignsByCampaignId", "No channelCampagins found", {
            channelCampagins,
            campaignId
          });
          return this.failed("Campaign data empty");
        }
        logger.log("Actions:getChannelCampaignsByCampaignId", "finished", {
          channelCampagins,
          campaignId
        });
        this.completed(channelCampagins);
      })
      .catch(this.failed);
  }
});

Actions.updateCampaignDeployedStatus.listen(function (campaignId, status) {
  logger.log("Actions:updateCampaignDeployedStatus", "Start update campaign deployed status...", {
    campaignId,
    status
  });
  database
    .updateCampaignWithId(campaignId, { deployed: status })
    .then(() => {
      logger.log("Actions:updateCampaignDeployedStatus", "update successful", {
        campaignId
      });
      this.completed(status);
    })
    .catch((error) => {
      logger.log("error:Actions:updateCampaignDeployedStatus", "failed updating collection", {
        error,
        campaignId
      });
      this.failed(error);
    });
});

Actions.updateCampaignAdsets.listen(function (campaignId, data = {}) {
  logger.log("Actions:updateCampaignAdsets", "called...", { campaignId });
  database
    .getAdsetsByCampaignId(campaignId)
    .then(async (results) => {
      logger.log("Actions:updateCampaignAdsets", "adsets from campaign Id", {
        campaignId,
        results
      });
      for (const result of results) {
        const adset = await database.updateAdsetById(result.id, data);
        logger.log("Actions:updateCampaignAdsets", "adset updated", {
          adset,
          campaignId
        });
      }
      this.completed(results);
    })
    .catch((error) => {
      logger.log("error:Actions:updateCampaignAdsets", "failed updating adsets from talentbait", {
        error,
        campaignId
      });
      this.failed(error);
    });
});

Actions.updateCampaignWithId.listen(function (campaignId, data = {}) {
  logger.log("Actions:updateCampaignWithId", "called...", { campaignId, data });
  database
    .updateCampaignWithId(campaignId, data)
    .then((result) => {
      logger.log("Actions:updateCampaignWithId", "update successful", {
        campaignId
      });
      this.completed(result);
    })
    .catch((error) => {
      logger.log("error:Actions:updateCampaignWithId", "failed updating collection", {
        error,
        campaignId
      });
      this.failed(error);
    });
});

Actions.deleteCampaignField.listen(function (campaignId, field) {
  database.deleteCampaignField(campaignId, field).then(this.completed).catch(this.failed);
});

Actions.addLocations.listen(function (label, data = {}) {
  logger.log("Actions:addLocations", "called...", { label, data });
  database
    .addLocations(label, data)
    .then((result) => {
      logger.log("Actions:addLocations", "update successful");
      this.completed(result);
    })
    .catch((error) => {
      logger.log("error:Actions:addLocations", "failed updating collection", { error });
      this.failed(error);
    });
});

Actions.changeCampaignData.listen(function (orgaId, campaignId, field, value) {
  logger.log("Actions:changeCampaignData", "called...", {
    orgaId,
    campaignId,
    field,
    value
  });
  logger.debug("Actions:changeCampaignData", "called...", { orgaId, campaignId, field, value });
  //TODO: Add organizationId
  const data = { [field]: value };

  logger.debug("Actions:changeCampaignData", "called (2)...", { orgaId, campaignId, data });

  database
    .updateCampaignWithId(campaignId, data)
    .then(() => {
      logger.log("Actions:changeCampaignData", "update successful", { campaignId, ...data });
      return this.completed(orgaId, campaignId, field, value);
    })
    .catch((error) => {
      logger.log("error:Actions:changeCampaignData", "failed updating collection", {
        error,
        campaignId,
        dataToChange: data
      });
      return this.failed(error);
    });
});

Actions.changeLeadAdData.listen(function (orgaId, campaignId, field, value) {
  logger.log("Actions:changeLeadAdData", "called...", { orgaId, campaignId, field, value });
  //TODO: Add organizationId
  const data = { [field]: value };
  database
    .updateLeadAdWithId(campaignId, data)
    .then(() => {
      this.completed(orgaId, campaignId, field, value);
    })
    .catch(this.failed);
});

Actions.loadSingleNotification.listen(function (notificationId) {
  logger.log("Actions:loadSingleNotification", "called...", { notificationId });

  database
    .getNotificationWithId(notificationId)
    .then((notificationData) => {
      if (!notificationData) {
        return this.failed("Campaign data empty");
      }

      this.completed(_.extend({}, notificationData.data(), { id: notificationId }));
    })
    .catch(this.failed);
});

Actions.loadCampaigns.listen(function (orgaId, filter, fieldName = "organizationId", fieldValue) {
  const user = auth.getCurrentUser();
  //------------------------------------------------------------
  // Little semantic explaination:
  // The filter value "ALL" is a special case, as it means that
  // we return all campaigns regardless of the state field.
  if (!filter) {
    filter = "ALL";
  }

  if (!(user && user.uid)) {
    logger.log("error:Actions:loadCampaigns", "No user id found", { orgaId, filter, fieldValue });
    return this.failed("User not logged in");
  }
  logger.debug("Actions:loadCampaigns", "↪ Check rank of member...", {
    orgaId,
    filter,
    fieldName,
    userId: user.uid
  });
  database.checkRankofMember(orgaId, user.uid).then((userRank) => {
    logger.debug("Actions:loadCampaigns", "Found a rank of user", {
      userRank,
      orgaId,
      filter,
      fieldName,
      fieldValue
    });
    //--------------------------------------------------------------
    // If the user is an admin, make sure to load all jobs
    // and not only the jobs of the logged in member
    //--------------------------------------------------------------
    if (
      userRank === "admin" ||
      userRank === "analyst" ||
      userRank === "HR-ADMIN" ||
      userRank === "ANALYST"
    ) {
      return callWebUtils(this, "loadAllCampaignsAPI", [{ organizationId: fieldValue, filter }]);
    }

    logger.log("Actions:loadCampaigns", "User is a member, so load only his own campaigns", {
      userId: user.uid
    });
    //--------------------------------------------------------------
    // If the user is just a regular member, we only load the campaigns
    // created by this user.
    //--------------------------------------------------------------
    return callWebUtils(this, "loadAllCampaignsAPI", [
      { userId: user.uid, filter, organizationId: fieldValue }
    ]);
  });
});

Actions.loadFilteredCampaigns.listen(function ({ organizationId, filters = {} }) {
  const user = auth.getCurrentUser();

  if (!(user && user.uid)) {
    logger.log("error:Actions:loadFilteredCampaigns", "No user id found", {});
    return this.failed("User not logged in");
  }

  database.checkRankofMember(organizationId, user.uid).then((userRank) => {
    //--------------------------------------------------------------
    // If the user is an admin, make sure to load all jobs
    // and not only the jobs of the logged in member
    //--------------------------------------------------------------
    if (
      userRank === "admin" ||
      userRank === "analyst" ||
      userRank === "HR-ADMIN" ||
      userRank === "ANALYST"
    ) {
      return callWebUtils(this, "loadFilteredCampaignsAPI", [{ organizationId, filters }]);
    }

    // TODO: test a regular member
    //--------------------------------------------------------------
    // If the user is just a regular member, we only load the campaigns
    // created by this user.
    //--------------------------------------------------------------
    return callWebUtils(this, "loadFilteredCampaignsAPI", [{ organizationId, filters }]);
  });
});

Actions.fetchAllOrganisations.listen(function () {
  logger.debug("Actions:AccountSystem:fetchAllOrganisations", "called...");
  database
    .getAllOrganizations()
    .then((snapshot) => {
      const orgas = [];
      snapshot.forEach(function (doc) {
        orgas.push(_.extend({}, doc.data(), { orgaId: doc.id }));
      });
      this.completed(orgas);
    })
    .catch(this.failed);
});

Actions.fetchAllUsers.listen(function () {
  logger.debug("Actions:AccountSystem:fetchAllUsers", "↪ called...");
  return database.fetchAllUsers().then(this.completed).catch(this.failed);
});

Actions.fetchAllActiveOrganisations.listen(function () {
  logger.debug("Actions:fetchAllActiveOrganisations", "called...");

  database
    .getAllActiveOrganizations()
    .then((snapshot) => {
      const orgas = [];
      snapshot.forEach(function (doc) {
        orgas.push(_.extend({}, doc.data(), { orgaId: doc.id }));
      });

      this.completed(orgas);
    })
    .catch(this.failed);
});

Actions.fetchAllNotifications.listen(function () {
  logger.log("Actions:fetchAllNotifications", "called...");

  database
    .getAllNotifications()
    .then((snapshot) => {
      const notifications = [];
      snapshot.forEach(function (doc) {
        notifications.push(_.extend({}, doc.data(), { docId: doc.id }));
      });
      this.completed(notifications);
    })
    .catch(this.failed);
});

Actions.updateAtsWithCampaignId.listen(function (campaignId, data) {
  logger.log("Actions:updateAtsWithCampaignId", "called...", { campaignId, ...data });
  return database.updateAtsWithCampaignId(campaignId, data).then(this.completed).catch(this.failed);
});
Actions.getCampaignPerformanceScoring.listen(function (data) {
  return callWebUtils(this, "getCampaignPerformanceScoring", [data]);
});

Actions.getCampaignCandidateMetrics.listen(function (campaignId) {
  return callWebUtils(this, "getCampaignCandidateMetrics", [campaignId]);
});

Actions.getDailyCandidateMetrics.listen(function (campaignId) {
  return callWebUtils(this, "getDailyCandidateMetrics", [campaignId]);
});

Actions.getEmployerBrandingMetrics.listen(function (campaignId) {
  return callWebUtils(this, "getEmployerBrandingMetrics", [campaignId]);
});

Actions.getPerformanceMetrics.listen(function (campaignId) {
  return callWebUtils(this, "getPerformanceMetrics", [campaignId]);
});

Actions.createOrgaByAdmin.listen(function (orgaData) {
  return database.createOrganizations(orgaData).then(this.completed).catch(this.failed);
});

Actions.getAllCampaignManagers.listen(function () {
  return callWebUtils(this, "getAllCampaignManagers", []);
});

Actions.getCampaignManagerById.listen(function (campaignManagerId) {
  return callWebUtils(this, "getCampaignManagerById", [campaignManagerId]);
});

Actions.updateCampaignManager.listen(function (campaignManagerId, data) {
  return callWebUtils(this, "updateCampaignManager", [campaignManagerId, data]);
});

Actions.getCampaignAndAdCreativesByCampaignId.listen(async function (
  campaignId,
  clientView,
  orgaId
) {
  logger.log(
    "Actions:getCampaignAndAdCreativesByCampaignId",
    "getCampaignAndAdCreativesByCampaignId called",
    {
      campaignId,
      clientView: clientView,
      orgaId: orgaId
    }
  );
  try {
    // Promise version of webutils call
    const getPublicCampaign = async () => {
      logger.log("Actions:getCampaignAndAdCreativesByCampaignId", "getting public campaign data", {
        campaignId
      });
      return new Promise((resolve, reject) => {
        callWebUtils(
          {
            completed: ({ payload }) => {
              logger.log(
                "Actions:getCampaignAndAdCreativesByCampaignId",
                "fetched public campaign data",
                {
                  ...payload,
                  campaignId
                }
              );
              resolve(payload);
            },
            failed: (error) => {
              reject(error);
            }
          },
          "loadCampaignDataPublic",
          [campaignId]
        );
      });
    };
    // Get ad previews and campaign data
    const [posts, campaignData] = await Promise.all([
      // Ad preview data from the database
      database.getAdCreativesByCampaignIdAndOrgaId(campaignId, orgaId),
      // If we are on the client view, fetch the campaign data from the backend
      // If we are on the admin view, fetch the campaign from the database
      clientView ? getPublicCampaign() : database.getCampaignWithId(campaignId)
    ]);
    logger.log(
      "Actions:getCampaignAndAdCreativesByCampaignId",
      "fetched campaign and ad preview data",
      {
        posts,
        campaignId,
        campaignData,
        clientView
      }
    );
    return this.completed({ campaignData: { ...campaignData, id: campaignId }, posts });
  } catch (error) {
    logger.log(
      "error:Actions:getCampaignAndAdCreativesByCampaignId",
      "unable to fetch campaign and ad preview data",
      {
        error,
        clientView,
        campaignId
      }
    );
    return this.failed(error);
  }
});

Actions.createCampaignDraft.listen(async function ({
  campaignGoal,
  draftCampaignId,
  previewPosts,
  previewAtsData,
  draftData,
  orgaId,
  atsId
}) {
  logger.log("Actions:createCampaignDraft", "called", {
    draftCampaignId,
    orgaId,
    atsId,
    campaignId: draftCampaignId,
    campaignGoal
  });

  try {
    let newPosts = previewPosts || [];

    if (draftCampaignId) {
      await database.updateCampaignDraft(draftCampaignId, draftData);

      logger.log("Actions:createCampaignDraft", "Delete draft", {
        draftCampaignId,
        campaignId: draftCampaignId,
        orgaId,
        atsId,
        campaignGoal
      });

      // NOTE:
      // This is a big decision here. Every time the user hits the "safe draft"
      // button, delete all the old ad previews and save the new ones.
      // Is there a better way to do this?
      //
      await database.deleteAdCreativesByCampaignIdAndOrgaId(draftCampaignId, orgaId);

      if ((previewPosts && previewPosts.length) > 0) {
        logger.log("Actions:createCampaignDraft", "has posts ", {
          draftCampaignId,
          campaignId: draftCampaignId,
          previewPosts,
          orgaId,
          atsId,
          campaignGoal
        });

        logger.log("Actions:createCampaignDraft", "check previewPosts before saving", {
          previewPosts,
          campaignId: draftCampaignId,
          draftCampaignId,
          atsId,
          campaignGoal
        });

        const updatedPosts = await database.saveAdCreatives(previewPosts);
        newPosts = updatedPosts;
      }

      Actions.addNotification(t("Draft updated!"));
    } else {
      logger.log("Actions:createCampaignDraft", "Try saving draft", {
        draftData,
        draftCampaignId,
        orgaId,
        atsId,
        campaignGoal
      });

      const newDraftCampaign = await database.createCampaignDraft(draftData);

      if (!newDraftCampaign) {
        logger.log("error:Actions:createCampaignDraft", "No draft doc found", {
          draftData,
          orgaId,
          campaignGoal,
          campaignId: draftCampaignId
        });

        return this.failed("No draft doc found");
      }

      logger.log("Actions:createCampaignDraft", "saved", {
        campaignId: newDraftCampaign.id,
        orgaId,
        atsId,
        draftCampaignId
      });

      previewPosts?.forEach((post) => {
        post.campaignId = newDraftCampaign.id;
      });

      logger.log("Actions:createCampaignDraft", "finished", {
        previewPosts,
        orgaId,
        atsId,
        campaignId: draftCampaignId
      });

      draftCampaignId = newDraftCampaign.id;

      // If we have previews for this BewerberHub campaign, make sure to update their job page url with the new
      // draft campaign ID
      if (previewPosts?.length && atsId) {
        previewPosts.forEach((previewPost) => {
          return (previewPost.channelData.url = previewPost.channelData.url.replace(
            atsId,
            draftCampaignId
          ));
        });
      }

      logger.log("Actions:createCampaignDraft", "save ad previews", {
        previewPosts: JSON.stringify(previewPosts),
        draftCampaignId,
        atsId,
        campaignId: draftCampaignId
      });

      if (previewPosts.length) {
        const updatedPosts = await database.saveAdCreatives(previewPosts);
        newPosts = updatedPosts;
      }

      // Copy auto generated ATS data with job page info on to campaign
      if (campaignGoal === "applicants") {
        await database.copyCampaignATSSettings(atsId, draftCampaignId).catch((error) => {
          logger.log("Actions:createCampaignDraft", "no ats auto generated", {
            error,
            draftCampaignId,
            orgaId,
            campaignId: draftCampaignId
          });
        });
      }

      Actions.addNotification(t("Draft was saved"));
    }

    logger.debug("Actions:createCampaignDraft", "Saving ats data", {
      previewAtsData,
      campaignGoal,
      isEmpty: !_.isEmpty(previewAtsData),
      draftCampaignId,
      campaignId: draftCampaignId
    });

    if (campaignGoal == "applicants" && !_.isEmpty(previewAtsData)) {
      await database.updateAtsWithCampaignId(draftCampaignId, previewAtsData);
    }

    logger.log("Actions:createCampaignDraft", "finished", {
      atsId,
      campaignId: draftCampaignId,
      newPosts
    });

    return this.completed({ draftCampaignId, newPosts });
  } catch (error) {
    logger.log("error:Actions:createCampaignDraft", "error", {
      error,
      draftCampaignId,
      campaignId: draftCampaignId,
      orgaId,
      draftData: JSON.stringify(draftData)
    });

    return this.failed({ error });
  }
});

Actions.loadDraftCampaign.listen(async function (campaignId, orgaId) {
  try {
    const [posts, campaignData] = await Promise.all([
      database.getAdCreativesByCampaignIdAndOrgaId(campaignId, orgaId),
      database.getCampaignWithId(campaignId)
    ]);

    // this is for backward compatibility with assistant new campaign
    const isAssistantNewCampaign =
      campaignData.type === "assistant" && campaignData.status === "new";

    /** @todo Handle draft upper and lower case and assistant new campaign */
    if (
      (!campaignData || campaignData.status?.toUpperCase() !== "DRAFT") &&
      !isAssistantNewCampaign
    ) {
      return this.failed("No draft campaign found");
    }
    return this.completed({ ...campaignData, id: campaignId, posts });
  } catch (error) {
    return this.failed(error);
  }
});

Actions.deleteDraftCampaign.listen(async function (campaignId, organizationId, removeCampaignById) {
  try {
    database.deleteCampaignDraft(campaignId);
    return this.completed({ campaignId, organizationId, removeCampaignById });
  } catch (error) {
    return this.failed(error);
  }
});

// User logs flag
Actions.createUserLogsFlat.listen(function (data) {
  logger.log("Actions:createUserLogsFlat", "called...", { ...data });
  return callWebUtils(this, "createUserLogsFlat", [data]);
});

// Add Orga logs
Actions.addOrgaLog.listen(function (orgaId, data) {
  return database.addOrgaLog(orgaId, data).then(this.completed).catch(this.failed);
});

Actions.saveBudgetCheck.listen(function (data) {
  return database.saveBudgetCheck(data).then(this.completed).catch(this.failed);
});

Actions.loadOrganizationOfCampaign.listen(function (orgaId) {
  const user = auth.getCurrentUser();

  logger.debug("Actions:loadOrganizationOfCampaign", "loadOrganizationOfCampaign listener", {
    userId: user.uid
  });

  if (!(user && user.uid)) {
    return logger.log("error:Actions:loadOrganizationOfCampaign", "User not logged in");
  }

  return callWebUtils(this, "loadOrganization", [orgaId]);
});

Actions.trackSegmentEvent.listen(function (data) {
  return callWebUtils(this, "trackSegmentEvent", [data]);
});

Actions.identifySegmentEvent.listen(function (data) {
  return callWebUtils(this, "identifySegmentEvent", [data]);
});

Actions.groupSegmentEvent.listen(function (data) {
  return callWebUtils(this, "groupSegmentEvent", [data]);
});

Actions.pageSegmentEvent.listen(function (data) {
  return callWebUtils(this, "pageSegmentEvent", [data]);
});

Actions.getAggregatedCreativeMetricsByHash.listen(function (data) {
  return callWebUtils(this, "getAggregatedCreativeMetricsByHash", [data]);
});

Actions.updateCampaignEndDate.listen(function (campaignId, data) {
  return callWebUtils(this, "updateCampaignEndDate", [campaignId, data]);
});

Actions.generateShareLinkForCampaign.listen(function (campaignId) {
  const context = {
    completed: (result) => Actions.generateShareLinkForCampaign.completed(result),
    failed: (error) => Actions.generateShareLinkForCampaign.failed(error)
  };
  return callWebUtils(context, "generateShareLinkForCampaign", [campaignId]);
});

Actions.getAllCompanies.listen(function (organizationId) {
  return callWebUtils(this, "getAllCompanies", [organizationId]);
});

Actions.getOrCreateCompany.listen(function (data) {
  return callWebUtils(this, "getOrCreateCompany", [data]);
});

export default Actions;
